import { useEffect } from "react";

import { getDiffDaysByDay } from "@/lib/dayjs/get-diff-days-by-day";
import { getTodaysDate } from "@/lib/dayjs/get-todays-date";

import { Table } from "@/components/ui/table/table";

const STOCK_TABLE_DAILY_ITEM_WIDTH = 80;
const STOCK_TABLE_ROOT_ID = "stock-table-root";

type UseAutoHorizontalScrollProps = {
	year: string;
	month: string;
};

/**
 * 操作月が今日の月と一致する場合、今日の日付までスクロールする
 */
const useAutoHorizontalScroll = ({ year: currentYear, month: currentMonth }: UseAutoHorizontalScrollProps) => {
	useEffect(() => {
		const tableRootElement = document.getElementById(STOCK_TABLE_ROOT_ID);
		const [year, month] = getTodaysDate().split("-");

		if (tableRootElement) {
			if (currentYear === year && currentMonth === month) {
				// 操作中の年月が今日の年月と一致する場合、今日の日付までスクロールする
				const todaysDate = getTodaysDate();
				const firstDay = `${currentYear}-${currentMonth}-01`;

				// その月が何日経過しているかを取得
				const daysPassed = getDiffDaysByDay(todaysDate, firstDay);

				tableRootElement.scrollTo({
					behavior: "auto",
					left: STOCK_TABLE_DAILY_ITEM_WIDTH * daysPassed,
				});
			} else {
				// 操作中の年月が今日の年月と一致しない場合、左端（月初）にスクロールする
				tableRootElement.scrollTo({
					behavior: "auto",
					left: 0,
				});
			}
		}
	}, [currentMonth, currentYear]);
};

type Props = {
	currentYearAndMonth: { year: string; month: string };
	children: React.ReactNode;
};

export const StockTable = ({ children, currentYearAndMonth: { year, month } }: Props) => {
	useAutoHorizontalScroll({ year, month });

	return (
		<Table id={STOCK_TABLE_ROOT_ID} className="relative w-full table-fixed" tableWrapperClassName="max-h-[800px]">
			{children}
		</Table>
	);
};

StockTable.displayName = "StockTable";
